import React from "react";
import useStyles from 'isomorphic-style-loader/useStyles'
import classes from './style.module.scss'
import { FormattedMessage } from "react-intl";
import { getSensorsUrl } from "../../../../../utils/sensor";
import withSource from '../../../../../hocs/source-scoll'

const Tag = withSource(props =>{
    const { tag, innerRef, position } = props;

    const handleProductClick = event => {
		event.preventDefault()

        const { currentTarget } = event;

		const href = currentTarget?.href
		window.location.href = getSensorsUrl(href, {
			resourcepage_title: currentTarget.getAttribute("data-title"),
			resource_type: currentTarget.getAttribute("data-type"),
            resource_position: currentTarget.getAttribute("data-position"),
			resource_content: currentTarget.getAttribute("data-content")
		})
	}

    return <a 
        onClick={handleProductClick}
        href={`/i/search/result?key=${encodeURIComponent(encodeURIComponent(tag.name))}`}  
        className={classes.Item}
        ref={innerRef}
        data-title={"product"}
        data-position={position}
        data-type="8"
        data-content={tag?.id}
    >{tag.name}</a>
})

const ProductRelatedSearches = props =>{
    useStyles(classes);
    const { productHooks } = props;
    const { selectedProduct } = productHooks;

    return <React.Fragment>
        {
            selectedProduct?.tags?.length > 0 && <div className={classes.ProductRelatedSearches}>
                <div className={classes.Title}><FormattedMessage id="related_searches" defaultMessage="Related Searches" /></div>

                <div className={classes.Bd}>
                    {
                        selectedProduct?.tags?.map((tag,index) =><Tag tag={tag} key={index} position={index+1} />)
                    }
                </div>
            </div>
        }
    </React.Fragment>
}

export default ProductRelatedSearches;